import { FormState, useWatch } from '@vtex/admin-ui-form'
import { SellerOperator, SellerRestriction } from 'typings'
import { useDrawerState } from '../../../Drawer'
import { Empty } from './Empty'
import { OptInList } from './List'
import { OptInView } from './View'

type Props = {
  form: FormState
  name: string
}

export function OptIn(props: Props) {
  const { form, name } = props

  const sellers: SellerRestriction | undefined = useWatch({
    form,
    name,
  })

  const editorState = useDrawerState()

  if (!sellers || sellers.operator !== SellerOperator.OPTIN) return null

  if (!sellers.items.length) return <Empty />

  const { items } = sellers

  return (
    <>
      <OptInView sellers={items} onClick={editorState.show} />
      <OptInList sellers={items} state={editorState} />
    </>
  )
}
